import React from 'react';
import { navigate } from 'gatsby';
import { FormattedMessage } from 'react-intl';
import { Button, buttonBtnTypeData, buttonSizeData, buttonSkinData } from '@luigiclaudio/ga-baseline-ui/button';
import { useLoading } from '@luigiclaudio/ga-baseline-ui/helpers';
import { useIdentityContext } from 'react-netlify-identity/dist';

var AuthLogoutButton = function AuthLogoutButton(_ref) {
  var btnType = _ref.btnType,
      skin = _ref.skin,
      size = _ref.size,
      disabled = _ref.disabled,
      navigateTo = _ref.navigateTo,
      logoutCallback = _ref.logoutCallback;

  var _useIdentityContext = useIdentityContext(),
      user = _useIdentityContext.user,
      logoutUser = _useIdentityContext.logoutUser;

  var _useLoading = useLoading(),
      isLoading = _useLoading[0],
      load = _useLoading[1];

  var handleLogoutUser = function handleLogoutUser() {
    load(logoutUser()).then(function () {
      navigate(navigateTo || '/signIn');
      logoutCallback();
    }).catch(function (err) {
      throw err;
    });
  };

  if (!user) {
    return null;
  }

  return /*#__PURE__*/React.createElement(Button, {
    btnType: btnType,
    onClick: handleLogoutUser,
    loading: isLoading,
    skin: skin,
    size: size,
    disabled: disabled
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "auth.logout.button.label"
  }));
};

AuthLogoutButton.defaultProps = {
  btnType: undefined,
  skin: undefined,
  size: undefined,
  disabled: false,
  navigateTo: undefined,
  logoutCallback: function logoutCallback() {}
};
export default AuthLogoutButton;